module.exports = __webpack_public_path__ + "img/galeria.86456abc.jpg";